import { useState } from "react";
import { CalendarPlus } from "lucide-react";
import { api } from "@/lib/api";
import { ApptDialog } from "@/components/ApptDialog";

export const masMeses = (iso, n) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setMonth(d.getMonth() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const AgendarRevisionButton = ({ patient, fecha, onDone, testId, label = "Agendar revisión", titulo = "Revisión (no aprobó terapia visual)", extra = {} }) => {
  const [appt, setAppt] = useState(null);
  const [profs, setProfs] = useState([]);
  const open = async () => {
    const { data } = await api.get("/profesionales", { params: { centro: patient.centro || "" } });
    setProfs(data);
    setAppt({
      tipo: "revision", profesional_id: data[0]?.id || "", fecha, inicio: "10:00", fin: "10:45",
      titulo, patient_id: patient.id, ...extra,
      patient: { id: patient.id, nombre: patient.nombre, telefono: patient.telefono, centro: patient.centro },
    });
  };
  return (
    <>
      <button type="button" onClick={open} data-testid={testId} className="inline-flex items-center gap-1 rounded-md border border-sky-300 bg-sky-50 px-2.5 py-1 text-xs font-medium text-sky-800 hover:bg-sky-100">
        <CalendarPlus className="h-3.5 w-3.5" />{label}
      </button>
      <ApptDialog appt={appt} profs={profs} onClose={() => setAppt(null)} onSaved={() => { setAppt(null); onDone?.(); }} />
    </>
  );
};
